export const SECTION_MAINTENANCE = {
  image: 'assets/imgs/section-maintenance/section-maintenance.svg',
  textLabel: 'MAINTENANCE.SECTIONS_MAINTENANCE_1',
  textLabel2: 'MAINTENANCE.SECTIONS_MAINTENANCE_2'
};
